import { takeEvery } from "redux-saga";
import sagaUtil from "./sagaUtil";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import * as consts from "../constants";
//It will check session ID and if it was not there, will initialize it
function* initializeSession(data) {
  //alert(JSON.stringify(data));
  yield sagaUtil.initializeSession(); //To check the session is created in server or not
  // load only if it's not there
  // yield put({ type: 'INITIALIZE_FORM' });
  // if(!(window.osa && window.osa.commonLookup)) {
  yield sagaUtil.fetch("gas/getlookups", null, (r) => {
    return {
      type: "LOOKUP",
      data: {
        lookup: { ...r.model },
        countryLookup: r.countryLookup,
        cities: r.cities,
        streetTypes: r.streetTypes,
        siteUrl: r.siteUrl,
        googleAnalyticsId: r.googleAnalyticsId,
        appVersion: r.appVersion,
        requiredByDateOffsetDays: r.requiredByDateOffsetDays,
        faq:
          data.service && data.service == "NewServiceApplicationType"
            ? r.faq
            : r.faqAban,
      },
    };
  });
  // }
  // if(!(data.user  && data.user.isAuthenticated))
  yield sagaUtil.fetch("account/getloggedinuser", 1, (r) => ({
    type: "LOGGEDIN_USER_LOADED",
    user: r.data,
    projectData: data,
  }));
}

function* getOffRampMessage() {
  yield sagaUtil.fetch("gas/getofframpmessage", null, (r) => ({
    type: "OFFRAMP",
    offramp: { message: r.message, isBPAuthenticated: r.isBPAuthenticated },
  }));
}

function* loggedinUserLoaded(data) {
  yield put({ type: "USER", user: data.user });

  if (data.user && data.user.bpNumber) {
    console.log(data.user.bpNumber);
    yield put({
      type: "LOAD_ACCOUNT",
      baNumber: "",
      bpNumber: data.user.bpNumber,
    });
    if (data.projectData.projectId) {
      const model = {
        IsWeb: true,
        ProjectNo: data.projectData.projectId,
        ApplicationType: data.projectData.service, //"NewServiceApplicationType","AbandonmentApplicationType"
        IsResumeProject: data.projectData.isCopy ? false : true,
      };
      yield put({
        type: "GET_PROJECT_DETAIL",
        model,
        isCopy: data.projectData.isCopy,
      });
    }
  }
}

function* getProjectDetail(data) {
  let callResult = null,
    projectDetailModel = null;
  yield sagaUtil.fetch("cafe/getprojectdetail", data.model, (r) => {
    callResult = r;
    projectDetailModel = actions.ProjectDetailReceived(r, data.isCopy);
    return projectDetailModel;
  });
  // console.log(projectDetailModel);
  if (callResult && !data.isCopy) {
    yield put({
      type: "LOAD_ACCOUNT",
      baNumber: callResult.model.baNumber,
      bpNumber: callResult.model.bpNumber,
    });
    const serviceType =
      data.model.ApplicationType == "NewServiceApplicationType"
        ? "NewServiceAttachment"
        : "ServiceAbandonment";
    let parcelModel = {
      Latitude: projectDetailModel.formModel.siteLat,
      Longitude: projectDetailModel.formModel.siteLong,
      ServiceType: serviceType, //'NewServiceAttachment','ServiceAbandonment'
    };
    const googleModel = {
      geometry: {
        location: { lat: parcelModel.Latitude, lng: parcelModel.Longitude },
      },
    };
    yield put({ type: "GET_PARCEL", model: parcelModel });
    yield put(
      actions.setGoogleLocation(googleModel, callResult.model.siteAddress)
    );
    const address1 = callResult.model.siteAddress;
    const address = {
      unitNumber: address1.unitNumber,
      streetNumber: address1.streetNumber,
      streetName: address1.streetName,
      poBox: address1.poBox,
      postCode: address1.postCode,
      streetType: { id: 0, name: address1.streetType, sortOrder: 0 },
      city: { id: 0, name: address1.city, sortOrder: 0 },
      province: { id: 0, name: address1.province, sortOrder: 0 },
      country: { id: 0, name: address1.country, sortOrder: 0 },
      coordinate: { id: 0, lat: 0, lng: 0 },
      addressType: { id: 0, name: "Project Address1", sortOrder: 0 },
      addressSubType: { id: 0, name: null, sortOrder: 0 },
      streetDirection: { id: 0, name: address1.streetDirection, sortOrder: 0 },
    };
    let model = {
      siteAddress: address1,
      buildingInfo:
        projectDetailModel.buildingType == "Single family dwelling"
          ? "1"
          : projectDetailModel.buildingType,
      isDuplexWith2Meters:
        projectDetailModel.buildingType == "Duplex" &&
        !projectDetailModel.isSingleMeterLocation,
      address,
    };
    if (serviceType == "NewServiceAttachment")
      yield put({ type: "CHECK_AVAILIBILITY", model });
    else {
      model = { Address: address1 };
      yield put({ type: "CHECK_OFFRAMP", model });
    }
  }
}

function* logOut() {
  yield sagaUtil.fetch("account/logout", 1, () => ({
    type: "LOGOUT",
    user: null,
  }));
}

function* getParcel(action) {
  yield put({ type: "ERROR", message: null });
  yield put({ type: "PARCEL", parcel: null });
  yield put({ type: "OFFRAMP", offramp: null });
  yield sagaUtil.fetch("gis/gas/getparceladdress", action.model, (r) => ({
    type: "PARCEL",
    parcel: {
      addressList: r.addressList,
      isOutsideGasArea: r.isOutsideGasArea,
      data: r.data,
    },
  }));
}

function* checkOffRamp(action) {
  yield put({ type: "ERROR", message: null });
  yield put({ type: "OFFRAMP", offramp: null });
  yield sagaUtil.fetch("gis/gas/checkofframp", action.model, (r) => ({
    type: "OFFRAMP",
    offramp: r.data,
  }));
}
function* verifyAccount(model) {
  const url = "sap/verifyRead/" + model.verifyfield + "/" + model.verifyvalue;
  yield put({ type: "CLEAR_BUPA_VERIFY_FAILED" });
  yield sagaUtil.fetch(
    url,
    null,
    (r) => ({ type: "BUPA_VERIFIED", model: { bpModel: r.model } }),
    (r) => ({ type: "BUPA_VERIFY_FAILED", model: r })
  );
}
function* submitOffRamp(action) {
  const api =
    action.model.ProductType == 0
      ? "common/requestcall"
      : "common/submitofframp";
  yield sagaUtil.fetch(api, action.model, (r) => ({
    type: "REQCALL",
    reqcall: { isSuccess: true, message: r.message },
  }));
}

function* logIn(action) {
  yield sagaUtil.fetch("account/login", action.model, (r) => ({
    type: "USER",
    user: r.data,
  }));
}

function* forgotPassword(action) {
  yield sagaUtil.fetch("account/forgotpassword", action.model, (r) => ({
    type: "FORGOT_PASSWORD_SUCCESS",
    forgotPasswordSuccess: r.success,
  }));
}

function* updateEmail(action) {
  yield put({ type: "UPDATE_EMAIL_SUCCESS", updateEmailSuccess: false });

  yield sagaUtil.fetch("account/updateprofileemail", action.model, (r) => ({
    type: "UPDATE_EMAIL_SUCCESS",
    updateEmailSuccess: r.success,
  }));
}

function* saveProfile(action) {
  yield put({ type: "SAVE_PROFILE_SUCCESS", saveProfileSuccess: false });

  yield sagaUtil.fetch("account/saveprofile", action.model, (r) => ({
    type: "SAVE_PROFILE_SUCCESS",
    saveProfileSuccess: r.success,
  }));
}

function* resetPassword(action) {
  yield put({ type: "RESET_PASSWORD_SUCCESS", resetPasswordSuccess: false });
  yield sagaUtil.fetch("account/resetpassword", action.model, (r) => ({
    type: "RESET_PASSWORD_SUCCESS",
    resetPasswordSuccess: r.success,
  }));
}

function* createProfile(action) {
  yield sagaUtil.fetch("account/register", action.model, (r) => ({
    type: "USER",
    user: r.data,
  }));
}
function* saveProject(action) {
  let projectNo = action.model.CafeData.ProjectNo;
  const api = projectNo ? "cafe/updateproject" : "cafe/saveproject";
  yield put({ type: "PROJECT_RESET_SUCCESS" });
  yield sagaUtil.fetch(api, action.model, (r) => ({
    type: "PROJECT",
    project: {
      isSuccess: true,
      data: r.resultModel,
      skipSchedule: r.skipSchedule,
      isRouteToDashboard: r.isRouteToDashboard,
      isRequiredByUpdated: r.isRequiredByUpdated,
    },
  }));
}
function* cancelProject(action) {
  yield sagaUtil.fetch("cafe/cancelproject", action.model, (r) => ({
    type: "CANCELLED_PROJECT",
    cancelledProject: { isSuccess: r.success },
  }));
}
function* submitProject(action) {
  const api =
    action.model.pageName == consts.NEW_GAS_LINE_NAME
      ? "gas/saverequest"
      : "gas/submitproject";
  yield sagaUtil.fetch(api, action.model, (r) => ({
    type: "SUBMITTED_PROJECT",
    submittedProject: {
      isSuccess: true,
      message: r.message,
      isCreditCheckRequired: r.isCreditCheckRequired,
    },
  }));
}
function* validateUsername(action) {
  yield put({ type: "INVALID_USER_NAME", invalidUserName: false });
  yield sagaUtil.fetch(
    "account/validateusername",
    action.model,
    (r) => ({ type: "INVALID_USER_NAME", invalidUserName: !r.isValid }),
    (r) => ({ type: "INVALID_USER_NAME", invalidUserName: !r.isValid })
  );
}
function* validateEmail(action) {
  yield put({ type: "INVALID_EMAIL", invalidEmail: false });
  yield sagaUtil.fetch(
    "account/validateemail",
    action.model,
    (r) => ({ type: "INVALID_EMAIL", invalidEmail: !r.isValid }),
    (r) => ({ type: "INVALID_EMAIL", invalidEmail: !r.isValid })
  );
}

function* loadAccount(action) {
  yield put({ type: "CLEAR_BUPA_VERIFY_FAILED" });
  let model = { BpNumber: action.bpNumber, BaNumber: action.baNumber };
  yield sagaUtil.fetch("sap/Read", model, () => ({
    type: "VERIFY_ACCOUNT",
    verifyfield: "BP number",
    verifyvalue: action.bpNumber,
  }));
}
//TODO : change account -> FortisBC Account
function* checkAccount(action) {
  yield put({ type: "CLEAR_BUPA_VERIFY_FAILED" });
  let model = { BpNumber: "", BaNumber: action.accountNumber };
  yield sagaUtil.fetch(
    "sap/Read",
    model,
    (r) => ({ type: "BUPA_CHECKED", model: r }),
    (r) => ({ type: "BUPA_CHECKED_FAILED", model: r })
  );
}

function* createAccount(model) {
  yield sagaUtil.fetch(
    "sap/createbupa",
    model.data,
    (r) => ({ type: "BUPA_CREATED", data: r }),
    (r) => ({ type: "BUPA_CREATE_FAILED", data: r })
  );
}
function* searchAccount(model) {
  yield put({ type: "BUPA_SEARCHED", data: null });
  yield put({ type: "SET_SEARCH_BP_WAIT_POPUP", value: true });
  yield sagaUtil.fetch("sap/searchbupa", model.data, (r) => ({
    type: "BUPA_SEARCHED",
    data: r,
  }));
}
function* updateAccount(model) {
  const bpModel = {
    ...model.data.businessPartnerModel,
    HasContractInLastTwoYears: true,
  }; // HasContractInLastTwoYears is only true for abandonment
  yield sagaUtil.fetch(
    "sap/updatebupa",
    bpModel,
    //in success case, we should check that baNumber is created . if not, CreateBuag should be called
    (r) => ({
      type: "BUPA_UPDATING",
      data: {
        ...r,
        BaNumber: bpModel.BaNumber,
        businessAgreementModel: model.data.businessAgreementModel,
      },
    }),
    //in failed senario, same as create failed
    (r) => ({ type: "BUPA_CREATE_FAILED", data: r })
  );
}

//{"success":true,"model":"6317052565"} -> model is ObjectId
function* accountUpdated(model) {
  const businessAgreementModel = {
    ...model.data.businessAgreementModel,
    ObjectId: model.data.model,
    BaNumber: model.data.BaNumber,
  };
  yield sagaUtil.fetch(
    "sap/addbuag",
    businessAgreementModel,
    (r) => ({ type: "BUAG_ADDED", data: r }),
    (r) => ({ type: "BUPA_CREATE_FAILED", data: r })
  );
}

function* callscheduling(action) {
  yield sagaUtil.fetch("scheduling/getschedule", action.model, (r) => ({
    type: "APPOINTMENTS",
    schedule: {
      start: action.model.Start,
      end: action.model.End,
      appointments: r.model,
    },
  }));
}

function* addEmail(action) {
  yield sagaUtil.fetch(
    "notification/addnotificationemail",
    action.model,
    (r) => ({ type: "ADD_EMAIL_SUCCESS", data: r })
  );
}

function* deleteEmail(action) {
  yield sagaUtil.fetch(
    "notification/deletenotificationemail",
    action.model,
    (r) => ({ type: "DELETE_EMAIL_SUCCESS", data: r })
  );
}
function* verifyEmail(action) {
  yield sagaUtil.fetch(
    "notification/verifynotificationemail",
    action.model,
    (r) => ({ type: "VERIFY_EMAIL_SUCCESS", data: r })
  );
}
function* updateNotification(action) {
  yield sagaUtil.fetch(
    "notification/updatenotificationemail",
    action.model,
    (r) => ({ type: "UPDATE_NOTIFICATION_SUCCESS", data: r })
  );
}

function* updateSchedule(action) {
  yield sagaUtil.fetch("cafe/updateproject", action.model, () => ({
    type: "SCHEDULE_UPDATED",
  }));
}

function* readPremise(action) {
  yield sagaUtil.fetch(
    "sap/readpremise",
    { PremiseNumber: action.premiseNumber },
    (r) => ({ type: "SAP_PREMISE", data: r.model })
  );
}

function* getProject(action) {
  yield sagaUtil.fetch("cafe/getprojectdetail", action.model, (r) => ({
    type: "PROJECT_DETAILS",
    projectDetails: { data: r.model, emailList: r.emaillist },
  }));
}
function* getProjectList() {
  yield sagaUtil.fetch("cafe/getprojectlist", null, (r) => ({
    type: "PROJECT_LIST_RECEIVED",
    data: r.model,
  }));
}
/*New Gas Line*/
function* checkAvailability(action) {
  yield put({ type: "ERROR", message: null });
  yield put({ type: "OFFRAMP", offramp: null });
  yield sagaUtil.fetch(
    "gis/gas/checkavailability",
    { ...action.model },
    (r) => ({
      type: "CHECK_AVAILABILITY_SUCCESS",
      data: { serviceCost: r.serviceCost, offramp: r.data },
    })
  );
}

function* saveContacts(action) {
  const contacts = action.contacts;
  let allSavedSuccess = true;
  for (let i = 0; i < contacts.length; i++) {
    const { name, ...contact } = contacts[i];
    yield sagaUtil.fetch(
      "sap/createcontact",
      contact,
      () => ({ type: "CONTACT_SAVED_SUCCESS", name }),
      () => {
        allSavedSuccess = false;
        return null;
      }
    );
  }
  yield put({ type: "CONTACTS_SAVED_FINISHED", allSavedSuccess });
}

function* toggleNotification(action) {
  yield sagaUtil.fetch(
    "notification/togglenotification",
    { ProjectNo: action.prjNo, IsActive: action.on },
    () => ({ type: "NOTIFICATION_TOGGLED" })
  );
}

function* toggleAllNotification(action) {
  for (let i = 0; i < action.prjs.length; i++) {
    yield toggleNotification({ prjNo: action.prjs[i], on: action.on });
  }
}

export function* watchGas() {
  yield [
    takeEvery("INITIALIZE_API", initializeSession),
    takeEvery("LOGGEDIN_USER_LOADED", loggedinUserLoaded),
    takeEvery("LOG_IN", logIn),
    takeEvery("FORGOT_PASSWORD", forgotPassword),
    takeEvery("RESET_PASSWORD", resetPassword),
    takeEvery("UPDATE_EMAIL", updateEmail),
    takeEvery("SAVE_PROFILE", saveProfile),
    takeEvery("LOG_OUT", logOut),
    takeEvery("GET_PARCEL", getParcel),
    takeEvery("CHECK_OFFRAMP", checkOffRamp),
    takeEvery("GET_OFFRAMP_MESSAGE", getOffRampMessage),
    takeEvery("SUBMIT_OFFRAMP", submitOffRamp),
    takeEvery("CHECK_ACCOUNT", checkAccount),
    takeEvery("LOAD_ACCOUNT", loadAccount),
    takeEvery("VERIFY_ACCOUNT", verifyAccount),
    takeEvery("VERIFY_EMAIL", verifyEmail),
    takeEvery("CREATE_ACCOUNT", createAccount),
    takeEvery("SEARCH_ACCOUNT", searchAccount),
    takeEvery("UPDATE_ACCOUNT", updateAccount),
    takeEvery("BUPA_UPDATING", accountUpdated),
    takeEvery("CREATE_PROFILE", createProfile),
    takeEvery("VALIDATE_USERNAME", validateUsername),
    takeEvery("VALIDATE_EMAIL", validateEmail),
    takeEvery("SAVE_PROJECT", saveProject),
    takeEvery("CANCEL_PROJECT", cancelProject),
    takeEvery("CALL_SCHEDULING", callscheduling),
    takeEvery("UPDATE_SCHEDULE", updateSchedule),
    takeEvery("SUBMIT_PROJECT", submitProject),
    takeEvery("ADD_EMAIL", addEmail),
    takeEvery("DELETE_EMAIL", deleteEmail),
    takeEvery("UPDATE_NOTIFICATION", updateNotification),
    takeEvery("READ_PREMISE", readPremise),
    takeEvery("GET_PROJECT_DETAIL", getProjectDetail),
    takeEvery("GET_PROJECT", getProject),
    takeEvery("GET_PROJECT_LIST", getProjectList),
    takeEvery("CHECK_AVAILIBILITY", checkAvailability),
    takeEvery("SAVE_CONTACTS", saveContacts),
    takeEvery("DB_SWITCH_PROJECT", toggleNotification),
    takeEvery("DB_SWITCH", toggleAllNotification),
  ];
}
